import type { DataGridStatus } from "../gridOptionTypes";

export interface DataGridStatusFlags {
    isLoading: boolean;
    isReady: boolean;
    isRefetching: boolean;
    /** Ready with no rows on the current page. */
    isEmpty: boolean;
    /** Ready with rows on the current page. */
    hasRows: boolean;
}

/** Ready, with a refetch running in the background. */
export const isStatusRefetching = (status: DataGridStatus) =>
    status.state === "ready" && Boolean(status.isRefetching);

/** One answer to "which state is the grid in" for the root and the viewport. */
export const getStatusFlags = ({
    status,
    rowCount,
}: {
    status: DataGridStatus;
    rowCount: number;
}): DataGridStatusFlags => {
    const isReady = status.state === "ready";
    return {
        isLoading: status.state === "loading",
        isReady,
        isRefetching: isStatusRefetching(status),
        isEmpty: isReady && rowCount === 0,
        hasRows: isReady && rowCount > 0,
    };
};
